import VueLoader from '../vue-loader'
import EventInterestForm from './form'

document.addEventListener('turbo:load', () => {
  VueLoader.loadVueComponent(EventInterestForm, document.getElementById('eventInterestsForm'))
})
